export const CONTACT_CONSTS = {
    GET_CONTACT: "GET_CONTACT",
};
